<template>
	<div>
		<section class="content-header mt-2">
			<h1 class="pull-left"><font-awesome-icon icon="file-alt" /> Reports</h1>
			<router-link class="btn btn-success pull-right" :to="{ name: 'report.create' }"><font-awesome-icon icon="plus" /></router-link>
		</section>
		<div class="content">
			<error-component
				v-if="exceptions.length > 0"
				v-bind="exceptions[0]">
			</error-component>
			<success-component
				v-if="success.length > 0"
				:message="success">
			</success-component>
			<div v-if="loading">
				<bouncing-component></bouncing-component>
			</div>
			<div v-else>
				<render-index-table v-if="reports.length > 0" :reports="reports"></render-index-table>
				
				<div class="empty query" v-else>
					<p>
						You don't have any report yet.
					</p>
					<div>
						<router-link tag="a" class="btn btn-success" :to="{ name: 'report.create' }">
							Make your first report.
						</router-link>
					</div>
				</div>
				<b-pagination align="center" size="md"
								:total-rows="pagination.totalRows"
								v-model="pagination.currentPage"
								:limit="pagination.limit"
								:per-page="pagination.limit"
								@change="change">
				</b-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import BouncingComponent from '../../components/Bouncing-loader.vue';
	import SuccessComponent from '../../components/Success.vue';
	import ErrorComponent from '../../components/ErrorView.vue';
	import {mapState} from 'vuex';
	import RenderIndexTable from './RenderIndexTable.vue';

	export default {
		data() {
			return {
				unwatch: '',
				loading: true
			}
		},
		computed: {
			...mapState('reports', {
				reports: 'items',
				pagination: 'pagination'
			}),
			...mapState({
				success: 'success',
				exceptions: 'exceptions'
			})
		},
		created() {
			let page = this.$route.query.page;
			if (page) {
				this.update(parseInt(page));
			}
			else {
				this.loading = true;
				this.$store.dispatch('reports/fetch').then(() => {
					this.loading = false;
				});
			}
			this.unwatch = this.$store.watch(
				(state)=>
					this.$store.state.organizationSelected
				,
				(newValue, oldValue)=>{
					this.$router.push({ name: 'report', query: { page: 1 } });
					this.$store.commit('reports/SET_PAGINATION', { current_page: 1, total: 0 });
					this.loading = true;
					this.$store.dispatch('reports/fetch').then(() => {
						this.loading = false;
					});
				},
			);
		},
		beforeDestroy() {
			this.$store.commit('reports/SET_REPORTS', []);
			this.$store.dispatch('clearMessages');
			this.unwatch();
		},
		methods: {
			change(page) {
				this.update(page);
				this.$router.push({ name: 'report', query: { page: page } });
			},
			update(page) {
				this.$store.commit('reports/SET_CURRENT_PAGE', page);
				this.loading = true;
				this.$store.dispatch('reports/fetch').then(() => {
					this.loading = false;
				});
			},
		},
		components: {
			SuccessComponent,
			ErrorComponent,
			BouncingComponent,
			RenderIndexTable
		}
	}
</script>